import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import { toList } from '../toList';

export const employeeNamesById = createSelector(getOrganization, function (organization) {
  const result: { [uuid: string]: string } = {};

  if (organization) {
    toList(organization.employeesById).forEach(function (e) {
      result[e.uuid] = e.firstName + ' ' + e.lastName;
    });
  }
  return result;
});
